module.exports = __webpack_public_path__ + "img/asset-tracker.27783d3d.svg";